import { render } from "./ProfileHistoryTable.vue?vue&type=template&id=2665c777"
import script from "./ProfileHistoryTable.vue?vue&type=script&lang=js"
export * from "./ProfileHistoryTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__